<script>
  import { onMount } from 'svelte';
  import { cart } from "../models/cart.js";
  import { formatPrice } from '../services/utilities.js';
  import Alert from "./Alert.svelte";

  export var isAdmin = false;
  export var product;
  export var compact;
  export var editable;
  export var returnToStock = null;
  let returnQuantity;
  let dimensions = null;
  let pieceCount = null;

  function imgUrl(image) {
    return image.url + image.filename + "-sm." + image.extension;
  }

  onMount(() => {
    if (product.attributes){
      product.attributes.forEach(a => {
        if (a.name === "Dimensions"){
          dimensions = a.value;
        } else if (a.name === "Piece Count"){
          pieceCount = a.value;
        }
      })
    }
  })
</script>

<style type="text/less">
  .cart-item {
    width: 100%;
    padding: var(--spacing-sm) 0;
    box-sizing: border-box;
    border-top: solid 1px var(--col-gray-80);

    .cart-item-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .cart-item-summary {
    display: flex;
  }

  .cart-item-alert {
    flex: 0 0 100%;
    box-sizing: border-box;
    padding: 0 var(--spacing-sm) var(--spacing-sm);
  }

  .cart-item-image {
    width: calc(var(--line-height) * 3);
    height: calc(var(--line-height) * 3);
    padding: 0 var(--spacing-sm);
  }

  .cart-item-info {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    font-size: 0.9rem;
    line-height: var(--line-height);
  }
  .cart-item-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 1rem;
  }

  .cart-item-quantity {
    flex-shrink: 0;
    line-height: var(--line-height);
    text-align: left;
  }

  .cart-item-quantity-price {
    display: flex;
    align-items: center;
    align-self: flex-end;
  }

  .cart-item-quantity *{
    padding: var(--spacing-xs);
  }

  .cart-btn {
    border: none;
    padding: var(--spacing-xs);
  }
  .cart-btn .icon {
    display: block;
  }

  .cart-item-price {
    display: block;
    text-align: right;
    padding: 0 var(--spacing-sm);
    min-width: 6ch;
  }

  /* Compact Styles */
  .compact .cart-item-image,
  .compact .cart-item-price,
  .compact .cart-item-sku,
  .compact .cart-item-type,
  .compact .subscription-alert,
  .static .cart-item-quantity .btn {
    display: none;
  }

  .compact .cart-item-content {
    flex-direction: row;
  }

  .subscription-alert {
    width: 90%;
  }

  @media(max-width:750px){
    .cart-item {
      width: 100%;
      padding: var(--spacing-sm) 0;
      box-sizing: border-box;
      border-top: solid 1px var(--col-gray-80);

      .cart-item-content {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        flex-direction: column;
      }
    }

    .cart-item-summary {
      margin-bottom: var(--spacing-lg);
    }

  }


</style>


<li class="cart-item" class:compact class:static={!editable}>
  {#if product.changed}
    <div class="cart-item-alert">
      <Alert type="danger" icon="warning">
        <ul class="list-unstyled">
          {#each product.changeMsgs as m}
            <li>{m}</li>
          {/each}
        </ul>
      </Alert>
    </div>
  {/if}

  <div class="cart-item-content">
    <div class="cart-item-summary">
      {#if !compact}
      <div class="cart-item-image">
        {#if product.images && product.images.length && product.images[0].url != ''}
          <img
            src={imgUrl(product.images[0])}
            class="image-fill"
            alt={product.images[0].title} />
        {:else}
          <img
            src="/assets/logo.jpg"
            class="image-fill"
            alt="Missing Piece Logo" />
        {/if}
      </div>
      {/if}

      <div class="cart-item-info">
        {#if !isAdmin}
          <a href="/product/{product.title}/sku/{product.sku}" class="cart-item-title">
            {product.title}
          </a>
        {:else}
          <a href="/admin/inventory/product/{product.sku}" class="cart-item-title">
            {product.title}
          </a>
        {/if}
        {#if !compact}
          {#if dimensions}
            <span class="cart-item-sku">{dimensions}</span>
          {/if}
          {#if pieceCount}
            <span class="cart-item-sku">{pieceCount} Pieces</span>
          {/if}
        <span class="cart-item-sku">{product.sku}</span>
        <span class="cart-item-type">{product.product_type.name}</span>
        {/if}
        {#if product.product_type.name === "Subscription"}
          <div class="subscription-alert">
            <Alert type="warning" icon="warning">
              After you finish purchasing your chosen subscription plan, please wait for an email on more information on how to checkout your rentals.
            </Alert>
          </div>
        {/if}
      </div>
    </div>

    <div class="cart-item-quantity-price">
      <div class="cart-item-quantity">
      {#if !compact}
        <!--Only show add/minus btns on full cart page-->
        <span class="cart-item-quantity-value">Quantity: {product.quantity}</span>
        <button
          class="btn cart-btn"
          on:click|stopPropagation={cart.remove(product)}>
          <svg class="icon">
            <use href="/icons.svg#minus" />
          </svg>
        </button>

        <button
          class="btn cart-btn"
          disabled={product.product_type.id !== 2 && product.product_type.id !== 3 && product.product_type.id !== 6}
          on:click|stopPropagation={cart.add(product)}>
          <svg class="icon">
            <use href="/icons.svg#plus" />
          </svg>
        </button>
      {:else}
        <span class="cart-item-quantity-value">Qty:{product.quantity}</span>
      {/if}
      </div>
      <div class="cart-item-price">
        {#if product.discount_price}
          <s>{formatPrice(product.price * product.quantity)}</s>
          {formatPrice(product.discount_price * product.quantity)}
        {:else if product.sale_price}
          <s>{formatPrice(product.price * product.quantity)}</s>
          {formatPrice(product.sale_price * product.quantity)}
        {:else}{formatPrice(product.price * product.quantity)}{/if}
      </div>
    </div>


      <!--TODO: rip out for admin page only -->
      {#if returnToStock !== null}
        <div class="cart-return">
        {#if product.quantity > product.returned_quantity}
          <select bind:value={returnQuantity}>
            {#each [...Array(product.quantity-product.returned_quantity).keys()] as i}
            <option value={i+1}>{i+1}</option>
            {/each}
          </select>
          <button
            disabled={product.quantity === product.returned_quantity}
            class="btn"
            on:click={() => {
              returnToStock(product, returnQuantity);
              product.returned_quantity += returnQuantity ;
            }}>
            Return to Stock
          </button>
        {:else}
          <button disabled class="btn">Returned</button>
        {/if}
        </div>
      {/if}
  </div>
</li>
